import * as Yup from 'yup';

export const NovaSolicitacaoValidation = Yup.object({
  descricao: Yup.string().required('Campo obrigatório'),
});